import { Col, Table, TableActionBarRow } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useRolesContext } from "../../hooks/roles/useRolesContext";
import { useManageHoops } from "../../hooks/hoops/useManageHoops";
import { PublishedState } from "../state/PublishedState";
import { TableCellLink } from "../table/TableCellLink";
import { ControlcenterMelcoModelsHoopListItem } from "melco-shared-logic";
import { FormattedDate } from "../table/FormattedDate";
import { ManageHoopsFilter } from "./ManageHoopsFilter";

type ManageHoopsListPropTypes = {
  isHoopDrawerOpen: boolean;
  setHoopDrawerOpenFunction: (v: boolean) => void;
  hoopIdToUpdate: string;
  // hoopType: string;
};

const DETAIL_VIEW_PATH = "/system/managehoops";
export const ManageHoopsList: React.FC<ManageHoopsListPropTypes> = () => {
  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    onTableConfigChange,
    pagination,
    filtersChange,
  } = useManageHoops();
  const { t } = useTranslation();
  const { roles } = useRolesContext();

  const columns = [
    {
      title: t("managehoops.table.columns.hoop_id"),
      key: "cloud_id",
      sorter: true,
      render: (rowObj: ControlcenterMelcoModelsHoopListItem) => {
        return roles.SYSTEM_HOOPS_EDIT ? (
          rowObj?.version !== 1 ? <TableCellLink
            onClick={() => {
            }}
            to={[DETAIL_VIEW_PATH, rowObj.cloud_id].join("/")}
          >
            {rowObj.cloud_id}
          </TableCellLink> : <TableCellLink to={""} onClick={() => alert(t("managehoops.alert.message"))}>  {rowObj.cloud_id}</TableCellLink>
        ) : (
          rowObj.cloud_id
        );
      },
    },
    {
      title: t("managehoops.table.columns.id"),
      key: "id",
      sorter: true,
      dataIndex: "id",
      // render: (rowObj: ControlcenterMelcoModelsHoopListItem) => {
      //   return roles.SYSTEM_HOOPS_EDIT ? (
      //     rowObj?.version !== 1 ? <TableCellLink
      //       onClick={() => {
      //         // handleEditClick(rowObj?.id ?? "")
      //       }}
      //       to={[DETAIL_VIEW_PATH, rowObj.id].join("/")}
      //     >
      //       {rowObj.id}
      //     </TableCellLink> : <TableCellLink to={""} onClick={() => alert(t("managehoops.alert.message"))}>  {rowObj.id}</TableCellLink>
      //   ) : (
      //     rowObj.id
      //   );
      // },
    },
    // {
    //   title: t("managehoops.table.columns.code"),
    //   key: "code",
    //   dataIndex: "code",
    //   sorter: true,

    // },
    {
      title: t("managehoops.table.columns.name"),
      key: "name",
      dataIndex: "name",
      sorter: true,
    },
    {
      title: t("managehoops.table.columns.english_dimensions"),
      key: "english_dimensions",
      dataIndex: "english_dimensions",
      sorter: true,
    },
    {
      title: t("managehoops.table.columns.metric_dimensions"),
      key: "metric_dimensions",
      dataIndex: "metric_dimensions",
      sorter: true,
    },

    {
      title: t("managehoops.table.columns.created_date"),
      key: "created_date",
      sorter: true,

      render: (rowObj: ControlcenterMelcoModelsHoopListItem) => (
        <> {<FormattedDate date={rowObj.created_date} />}</>
      ),
    },
    {
      title: t("managehoops.table.columns.published_date"),
      key: "published_date",
      sorter: true,

      render: (rowObj: ControlcenterMelcoModelsHoopListItem) => (
        <> {<FormattedDate date={rowObj.published_date} />}</>
      ),
    },
    {
      title: t("managehoops.table.columns.publish_state"),
      key: "publish_state",
      sorter: true,
      render: (rowobj: ControlcenterMelcoModelsHoopListItem) => {
        return <PublishedState publishedState={rowobj.publish_state ?? 1} />;
      },
    },
  ];

  return (
    <>
      <TableActionBarRow>
        <Col xs={24} md={24} xl={24}>
          <ManageHoopsFilter onFiltersChange={filtersChange} />
        </Col>
      </TableActionBarRow>

      <Table
        showSorterTooltip={false}
        sticky
        loading={isPreviousData ? isFetching : isLoading}
        dataSource={data}
        columns={columns}
        onChange={onTableConfigChange}
        pagination={pagination}
        rowKey="id"
        noDataMessage={t("managehoops.table.no_hoops_message")}
        errorComponent={errorComponent}
      />
    </>
  );
};
